import React from 'react';
import { MessageCircle } from 'lucide-react';
import { COMPANY } from '../content/seo';
import { trackEvent } from '../utils/analytics';

const WA_URL = `https://wa.me/${COMPANY.whatsapp}?text=Hi%20Bison%20Food%20Solutions,%20I%27d%20like%20to%20learn%20more.`;

export default function FloatingWhatsapp() {
  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent('whatsapp_click', { location: 'floating' })}
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-2xl rounded-full p-4 flex items-center gap-2 transition-transform hover:scale-105"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp"
    >
      <MessageCircle className="w-6 h-6" />
      <span className="hidden sm:inline font-medium">WhatsApp us</span>
    </a>
  );
}
